'use client';

import cn from '@/utils/cn';
import * as LabelPrimitive from '@radix-ui/react-label';

type LabelProps = {
  children: React.ReactNode;
  className?: string;
  htmlFor?: string;
};

export default function Label({ children, className, htmlFor }: LabelProps) {
  return (
    <LabelPrimitive.Root
      className={cn(
        'text-sm font-medium text-gray-700 hover:cursor-pointer block',
        className,
      )}
      htmlFor={htmlFor}
    >
      {children}
    </LabelPrimitive.Root>
  );
}
